export type PsimFieldGroup = 'ri' | 'severity' | 'total';

export type PsimField = {
  key: string;
  label: string;
  subLabel: string;
  group: PsimFieldGroup;
};

export const PSIM_BASE_FIELDS: PsimField[] = [
  { key: 'ri0', label: 'Ri0', subLabel: 'Area', group: 'ri' },
  { key: 'ri1', label: 'Ri1', subLabel: 'Area', group: 'ri' },
  { key: 'ri2', label: 'Ri2', subLabel: 'Area', group: 'ri' },
  { key: 'ri3', label: 'Ri3', subLabel: 'Area', group: 'ri' },
  { key: 'ri4', label: 'Ri4', subLabel: 'Area', group: 'ri' },
  { key: 'ri5', label: 'Ri5', subLabel: 'Area', group: 'ri' },
  { key: 'light', label: 'Light', subLabel: 'Area', group: 'severity' },
  { key: 'moderate', label: 'Moderate', subLabel: 'Area', group: 'severity' },
  { key: 'heavy', label: 'Heavy', subLabel: 'Area', group: 'severity' },
];

export const PSIM_REMEDIATION_FIELDS: PsimField[] = [
  ...PSIM_BASE_FIELDS,
  { key: 'riskAreaRemediationScore', label: 'Remaining', subLabel: 'Score', group: 'total' },
];
